<script setup lang="ts">
import Icon from '@spectee/components/Atoms/IconBase/index.vue';
defineExpose({
  name: 'PageNumber',
});

interface Props {
  href?: string;
  num?: number;
  isActive?: boolean;
  isOmission?: boolean;
  isPrev?: boolean;
  isNext?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  href: '',
  num: 1,
  isActive: false,
  isOmission: false,
  isPrev: false,
  isNext: false,
});
</script>

<template>
  <span
    v-if="isActive || isOmission"
    class="PageNumber"
    :class="[
      {
        'PageNumber--active': isActive,
        'PageNumber--omission': isOmission,
      },
    ]"
  >
    <span v-if="!isOmission && num" class="PageNumber__num">{{ num }}</span>
    <span v-if="isOmission" class="PageNumber__omission">…</span>
  </span>

  <button
    v-else
    class="PageNumber"
    :aria-label="isPrev ? '前へ' : isNext ? '次へ' : ''"
  >
    <span v-if="!isPrev && !isNext && num" class="PageNumber__num">{{
      num
    }}</span>
    <Icon
      v-if="isPrev || isNext"
      class="PageNumber__icon"
      :iconName="isPrev ? 'Left' : isNext ? 'Right' : ''"
    />
  </button>
</template>

<style lang="scss" scoped>
@use '@spectee/assets/scss/_forward.scss' as *;

.PageNumber {
  position: relative;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  width: $service-unit * 5;
  height: $service-unit * 5;
  font-size: $service-font-size-pp;
  color: $color-gray-60;
  cursor: pointer;
  background-color: transparent;

  &::before {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 0;
    display: none;
    width: $service-unit * 5;
    height: $service-unit * 5;
    content: '';
    background-color: $color-gray-20;
    border-radius: $service-border-radius-circle;
  }

  &:hover:not(&--active) {
    &::before {
      display: block;
    }
  }

  &--active {
    font-weight: bold;
    color: $color-gray-80;
    cursor: default;
  }

  &--omission {
    pointer-events: none;
    border: none;

    &:hover {
      cursor: default;
    }
  }

  &__num {
    position: relative;
    z-index: 1;
  }

  & &__icon {
    position: relative;
    z-index: 1;
    width: $service-unit * 5;
    height: $service-unit * 5;
    color: $color-gray-80;
  }
}
</style>
